import { readEnvVariable } from '../helpers';

export interface IBillingEnv {
  appleApiPrivateKey: string | null;
  googleServiceAccountKey: string | null;
  cafebazaarRsaKey: string | null;
  revenueCatWebhookAuthSecret: string | null;
}

export function getBillingEnv(): IBillingEnv {
  const appleApiPrivateKey = readEnvVariable('APPLE_API_PRIVATE_KEY') || null;
  const googleServiceAccountKey = readEnvVariable('GOOGLE_SERVICE_ACCOUNT_KEY') || null;
  const cafebazaarRsaKey = readEnvVariable('CAFEBAZAAR_RSA_KEY') || null;
  const revenueCatWebhookAuthSecret = readEnvVariable('REVENUECAT_WEBHOOK_AUTH_SECRET') || null;

  return {
    appleApiPrivateKey,
    googleServiceAccountKey,
    cafebazaarRsaKey,
    revenueCatWebhookAuthSecret,
  };
}
